(function () {
  'use strict';

  function getCartIconEl() {
    return (
      document.querySelector('.header__icon--cart') ||
      document.querySelector('a[href*="/cart"].header__icon') ||
      document.querySelector('[data-cart-icon]') ||
      document.querySelector('a[href="/cart"]')
    );
  }

  function getProductImgSrc(btn) {
    var card =
      btn.closest('.card-wrapper') ||
      btn.closest('.product-card') ||
      btn.closest('li.grid__item') ||
      btn.closest('article') ||
      btn.closest('[id^="MainProduct"]') ||
      btn.closest('.product__info-container') ||
      btn.closest('section');

    if (!card) return null;

    var img =
      card.querySelector('.product__media--active img') ||
      card.querySelector('.card__media img') ||
      card.querySelector('.product__media img') ||
      card.querySelector('[data-media-type="image"] img') ||
      card.querySelector('img:not([aria-hidden])') ||
      card.querySelector('img');

    return img ? (img.currentSrc || img.src) : null;
  }

  function popCartIcon(cartEl) {
    if (!cartEl) return;
    cartEl.classList.remove('cart-icon--popping');
    void cartEl.offsetWidth;
    cartEl.classList.add('cart-icon--popping');
    cartEl.addEventListener('animationend', function handler() {
      cartEl.classList.remove('cart-icon--popping');
      cartEl.removeEventListener('animationend', handler);
    });
  }

  function flyToCart(fromEl, imgSrc) {
    var cartEl = getCartIconEl();
    if (!cartEl) return;

    var fromRect = fromEl.getBoundingClientRect();
    var toRect   = cartEl.getBoundingClientRect();

    var startX = fromRect.left + fromRect.width  / 2;
    var startY = fromRect.top  + fromRect.height / 2;
    var endX   = toRect.left   + toRect.width    / 2;
    var endY   = toRect.top    + toRect.height   / 2;

    var R  = 90;
    var cx = startX;
    var cy = startY - R;

    var steps     = 50;
    var keyframes = [];

    for (var i = 0; i <= steps; i++) {
      var t  = (i / steps) * 2 * Math.PI;
      var px = cx + R * Math.sin(t);
      var py = cy + R * Math.cos(t);
      keyframes.push({ left: px + 'px', top: py + 'px', opacity: '1', offset: (i / steps) * 0.78 });
    }

    keyframes.push({ left: endX + 'px', top: endY + 'px', opacity: '0', offset: 1.0 });

    var dot = document.createElement('div');
    dot.className = 'cart-fly-dot';
    dot.style.left = startX + 'px';
    dot.style.top  = startY + 'px';

    if (imgSrc) {
      var img = document.createElement('img');
      img.src = imgSrc;
      img.alt = '';
      dot.appendChild(img);
    } else {
      dot.classList.add('cart-fly-dot--emoji');
      dot.textContent = '\uD83D\uDED2';
    }

    document.body.appendChild(dot);

    dot.animate(keyframes, {
      duration: 1400,
      easing:   'ease-in-out',
      fill:     'forwards'
    }).onfinish = function () {
      dot.remove();
      popCartIcon(cartEl);
    };
  }

  document.addEventListener('click', function (e) {
    var btn =
      e.target.closest('button[name="add"]') ||
      e.target.closest('.product-form__submit') ||
      e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    var imgSrc = getProductImgSrc(btn);
    flyToCart(btn, imgSrc);
  }, true);

})();
